/**
 * @generated SignedSource<<810b1bfa0c88c609c6b1f03b5e56d1d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ViewerTreeStateKind = "CanBeStarted" | "CanNotBeStarted" | "IsFinished" | "IsStarted" | "NotVisible" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PaediaTreeAdvancementMessage_NodeFragment$data = {
  readonly structureDefinition: {
    readonly extension?: {
      readonly wordpressCertificates?: ReadonlyArray<{
        readonly id: string;
      } | null>;
    };
    readonly viewerTreeState?: {
      readonly kind: ViewerTreeStateKind;
    };
  };
  readonly " $fragmentType": "PaediaTreeAdvancementMessage_NodeFragment";
};
export type PaediaTreeAdvancementMessage_NodeFragment$key = {
  readonly " $data"?: PaediaTreeAdvancementMessage_NodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaediaTreeAdvancementMessage_NodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaediaTreeAdvancementMessage_NodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "structureDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "viewerTreeState",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "extension",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WordpressCertificateAndLearnState",
                      "kind": "LinkedField",
                      "name": "wordpressCertificates",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "LearnOpportunityRootExtensionImpl",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "LearnOpportunityRootStructureDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LearnOpportunityV2",
  "abstractKey": null
};

(node as any).hash = "c86f954d4af55074132be5db063303a2";

export default node;
